import { useAuth as authContext } from "../context/AuthContext";
import { jwtDecode } from "jwt-decode"; // Install: npm install jwt-decode

const useAuth = () => {
  const {
    authState,
    login,
    logout,
    refreshToken,
    saveAuth,
    setUser: setContextUser,
    refreshUser: refreshContextUser,
  } = authContext();

  // ✅ Check if token is expired
  const isTokenExpired = (token) => {
    if (!token) return true;
    
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decoded.exp < currentTime;
    } catch (error) {
      console.error("Error decoding token:", error);
      return true;
    }
  };

  // Utility functions
  const getUser = () => authState.user;
  const getAccessToken = () => authState.accessToken;
  
  // ✅ Updated isAuth to check token expiration
  const isAuth = () => {
    const token = authState.accessToken;
    if (!token) return false;
    
    // Check if token is expired
    if (isTokenExpired(token)) {
      // Token expired, logout user
      logout();
      return false;
    }
    
    return true;
  };
  
  const isLoading = () => authState.isLoading;

  return {
    user: getUser(),
    accessToken: getAccessToken(),
    isAuth: isAuth(),
    isLoading: isLoading(),
    login,
    logout,
    refreshToken,
    setUser: setContextUser,
    refreshUser: refreshContextUser,
    saveAuth,
  };
};

export default useAuth;
